import { compact } from 'lodash';

import { ENTITY_TYPES } from '../entities.constants';
import { EntityType } from '../types/EntityType';
import { getExtendedDisplayKindFromEntityType } from '../utils/getExtendedDisplayKindFromEntityType';

export interface EntityOption {
  label: string;
  value: EntityType;
  disabled?: boolean;
}

export function getEntityOptions(
  opts: {
    isInlineCreationScenario?: boolean;
  } = {
    isInlineCreationScenario: false,
  }
) {
  const trusts: EntityOption[] = compact([
    {
      label: getExtendedDisplayKindFromEntityType(
        ENTITY_TYPES.IRREVOCABLE_TRUST
      ),
      value: ENTITY_TYPES.IRREVOCABLE_TRUST,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.REVOCABLE_TRUST),
      value: ENTITY_TYPES.REVOCABLE_TRUST,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.SLAT),
      value: ENTITY_TYPES.SLAT,
    },
    // the GRAT designer pattern is too complicated to support inline creation
    !opts.isInlineCreationScenario && {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.GRAT),
      value: ENTITY_TYPES.GRAT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.ILIT),
      value: ENTITY_TYPES.ILIT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.QPRT),
      value: ENTITY_TYPES.QPRT,
    },
  ]);

  const personalAccounts: EntityOption[] = compact([
    {
      label: getExtendedDisplayKindFromEntityType(
        ENTITY_TYPES.INDIVIDUAL_ACCOUNT
      ),
      value: ENTITY_TYPES.INDIVIDUAL_ACCOUNT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.JOINT_ACCOUNT),
      value: ENTITY_TYPES.JOINT_ACCOUNT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(
        ENTITY_TYPES.RETIREMENT_ACCOUNT
      ),
      value: ENTITY_TYPES.RETIREMENT_ACCOUNT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(
        ENTITY_TYPES.INSURANCE_ACCOUNT
      ),
      value: ENTITY_TYPES.INSURANCE_ACCOUNT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(
        ENTITY_TYPES.CUSTODIAL_ACCOUNT
      ),
      value: ENTITY_TYPES.CUSTODIAL_ACCOUNT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(
        ENTITY_TYPES.QUALIFIED_TUITION_ACCOUNT
      ),
      value: ENTITY_TYPES.QUALIFIED_TUITION_ACCOUNT,
    },
  ]);

  const charitableEntities: EntityOption[] = [
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.CRT),
      value: ENTITY_TYPES.CRT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.CLT),
      value: ENTITY_TYPES.CLT,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.DAF),
      value: ENTITY_TYPES.DAF,
    },
    {
      label: getExtendedDisplayKindFromEntityType(
        ENTITY_TYPES.PRIVATE_FOUNDATION
      ),
      value: ENTITY_TYPES.PRIVATE_FOUNDATION,
    },
  ];

  const businessEntities: EntityOption[] = [
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.LLC),
      value: ENTITY_TYPES.LLC,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.GP),
      value: ENTITY_TYPES.GP,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.LP),
      value: ENTITY_TYPES.LP,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.S_CORP),
      value: ENTITY_TYPES.S_CORP,
    },
    {
      label: getExtendedDisplayKindFromEntityType(ENTITY_TYPES.C_CORP),
      value: ENTITY_TYPES.C_CORP,
    },
    {
      label: getExtendedDisplayKindFromEntityType(
        ENTITY_TYPES.SOLE_PROPRIETORSHIP
      ),
      value: ENTITY_TYPES.SOLE_PROPRIETORSHIP,
    },
  ];

  return { trusts, personalAccounts, charitableEntities, businessEntities };
}
